import React, { useEffect, useState } from 'react';
import { claimSingleWebphone, WEBPHONE_WINDOW } from '../../utils/singleWebphone';

// Puerta de /webphone: solo UNA ventana del Marcador por navegador puede montar el softphone (y registrar la
// extensión). Una segunda no registra: avisa a la primera para que se ponga al frente y se cierra sola.
// Va alrededor de SoftphoneProvider, así la ventana duplicada nunca llega a abrir el WebSocket SIP.
export default function WebphoneGate({ children }) {
  const [role, setRole] = useState('checking'); // checking | primary | duplicate

  useEffect(() => {
    let released = false;
    let claim = null;
    const flash = () => {          // el navegador puede negar el foco: el título parpadeando avisa de dónde está
      try { window.focus(); } catch { /* sin foco */ }
      const base = document.title;
      let n = 0;
      const t = setInterval(() => {
        document.title = n % 2 === 0 ? '📞 Marcador (aquí)' : base;
        if (++n > 7) { clearInterval(t); document.title = base; }
      }, 500);
    };
    claimSingleWebphone({
      locks: typeof navigator !== 'undefined' ? navigator.locks : undefined,
      makeChannel: typeof BroadcastChannel !== 'undefined' ? (n) => new BroadcastChannel(n) : undefined,
      onFocusRequest: flash,
    }).then((c) => {
      if (released) { c.release(); return; }
      claim = c;
      if (c.role === 'primary') { try { window.name = WEBPHONE_WINDOW; } catch { /* sin acceso */ } }
      setRole(c.role);
    });
    return () => { released = true; if (claim) claim.release(); };
  }, []);

  useEffect(() => {
    if (role !== 'duplicate') return undefined;
    const t = setTimeout(() => { try { window.close(); } catch { /* solo se cierran las abiertas por script */ } }, 2500);
    return () => clearTimeout(t);
  }, [role]);

  if (role === 'checking') return <div className="min-h-screen bg-gray-950" />;
  if (role === 'duplicate') {
    return (
      <div className="min-h-screen bg-gray-950 flex items-center justify-center p-6">
        <div className="max-w-md text-center text-gray-200">
          <h1 className="text-lg font-semibold mb-2">El Marcador ya está abierto</h1>
          <p className="text-sm text-gray-400">
            Solo puede haber una ventana del Marcador por navegador (la extensión admite un único dispositivo).
            Se ha avisado a la ventana abierta para que se ponga al frente; esta se cerrará sola.
            Si no se cierra, ciérrala y usa la otra.
          </p>
        </div>
      </div>
    );
  }
  return children;
}
